var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurnedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_82824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 23C10.497 22.9999 9.02885 22.5483 7.78576 21.7037C6.54266 20.8592 5.58195 19.6606 5.0282 18.2635C4.47444 16.8664 4.35318 15.3352 4.68013 13.8683C5.00709 12.4015 5.76718 11.0667 6.86185 10.037C8.19985 8.774 11.4998 6.5 10.9998 1.5C16.9998 5.5 19.9999 9.5 13.9999 15.5C14.9999 15.5 16.4999 15.5 18.9999 13.03C19.3041 13.8194 19.4731 14.6544 19.4999 15.5C19.4999 17.4891 18.7097 19.3968 17.3032 20.8033C15.8966 22.2098 13.989 23 11.9998 23Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_82824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurnedIcon);
export default __webpack_public_path__ + "static/media/burned-icon.c7f0853cec136b38699b8628216cb130.svg";
export { ForwardRef as ReactComponent };